import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { GET, DELETE } from '../../../API'; 
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";

// const MainPage = ({ onEdit, onDelete, onCreate }) => {
const MainPage = () => {
    const navigate = useNavigate();
    const { category } = useParams();
    const [forms, setForms] = useState([]);

    const onCreate = () => {
        // For now, just navigate to the form builder page
        // In a real app, you might also need to setup a blank state for the form
        navigate(`${category}/form-builder`);
    };

    useEffect(() => {
      getForms();
    },[])

    const getForms = async () => { 
      const response = await GET(`form/type/${category}`);
      const json = await response.json();
      setForms(json.results);
    }

    const onEdit = async (formId) => {
        try {
            navigate({
              pathname: `/${category}/form-builder/?form_id=${formId}`,
            });
        } catch (error) {
            console.error("Failed to fetch form data for editing:", error);
            alert("Failed to load form for editing.");
        }
    };
    

    const onDelete = async (formId, formName) => {
        if (!window.confirm(`למחוק את הטופס "${formName}"?`)) {
            return;
        }

        try {
            const response = await DELETE(`form/${formId}`);
            const json = await response.json().catch(() => ({}));

            if (response.ok) {
                alert("הטופס נמחק.");
                getForms();
                return;
            }

            // the server refuses to delete a form that requests were filed under,
            // because deleting it hides those requests instead of removing them
            if (response.status === 409) {
                alert(`לא ניתן למחוק את הטופס - הוגשו דרכו ${json.requests} בקשות.`);
                return;
            }

            alert(json.error || "מחיקת הטופס נכשלה.");
        } catch (error) {
            console.error("Error deleting form:", error);
            alert("אירעה שגיאה במחיקת הטופס.");
        }
    };

  return (
    <div className={styles.formsContainer}>
    <h1>Forms</h1>
    {forms.map(form => (
      <div key={form._id.$oid}>
        <h2>{form.name}</h2>
        <button onClick={() => onEdit(form._id.$oid)}>Edit</button>
        <button onClick={() => onDelete(form._id.$oid, form.name)}>Delete</button>
      </div>
    ))}
    <button onClick={onCreate}>Create New Form</button>
  </div>
  );
};


export default MainPage;
